import { render } from "./ProductCard.vue?vue&type=template&id=f296fce2&scoped=true&ts=true"
import script from "./ProductCard.vue?vue&type=script&lang=ts"
export * from "./ProductCard.vue?vue&type=script&lang=ts"

import "./ProductCard.vue?vue&type=style&index=0&id=f296fce2&lang=scss&scoped=true"

import exportComponent from "/home/ubuntu/buildAgent/work/a701a23a46ecd31f/bookit-pms/Solution.Cashier/front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f296fce2"]])

export default __exports__